import { useCallback } from "react";
import styled from "@emotion/styled";
import { MDSButton, MDSButtonSlotName, MDSIcon, MDSIconKind, MDSLink } from "@/mds";
import { APP_CONFIG } from "@/domains/global/config";
import { windowModule } from "@/modules/window";
import {
  SettingsIntegrationPageWrapper,
  SettingsIntegrationHeader,
  SettingsIntegrationScrollableArea,
  SettingsIntegrationSection,
  SettingsIntegrationBenefitCard,
} from "@/pages/settings/components/settings-integration-layout";

const StyledButtonRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing[2]};
  padding-top: ${({ theme }) => theme.spacing[3]};
  max-width: 700px;
`;

export const SettingsMcpPage = () => {
  const handleClaudeConnect = useCallback(() => {
    windowModule.openInNewTab({ url: new URL(APP_CONFIG.URLS.MCP_CLAUDE_CONNECT) });
  }, []);

  const handleChatGPTConnect = useCallback(() => {
    windowModule.openInNewTab({ url: new URL(APP_CONFIG.URLS.MCP_CHATGPT_CONNECT) });
  }, []);

  const handleMcpDocsOpen = useCallback(() => {
    windowModule.openInNewTab({ url: new URL(APP_CONFIG.URLS.MCP_DOCS) });
  }, []);

  const benefitPoints = [
    "Connect Claude and/or ChatGPT chatbot to Mem",
    "Chat with your entire Mem knowledge base as context",
    "Create, edit, organize, or ask about any notes and collections in your Mem",
    <>
      Refer to our <MDSLink onPress={handleMcpDocsOpen}>MCP docs</MDSLink> for more information
    </>,
  ];

  return (
    <SettingsIntegrationPageWrapper>
      <SettingsIntegrationHeader breadcrumb="Apps and integrations" title="MCP" />
      <SettingsIntegrationScrollableArea>
        <SettingsIntegrationSection>
          <SettingsIntegrationBenefitCard points={benefitPoints} />
          <StyledButtonRow>
            <MDSButton onPress={handleClaudeConnect}>
              <MDSIcon kind={MDSIconKind.Anthropic} slot={MDSButtonSlotName.LeftIcon} />
              Connect Mem with Claude
              <MDSIcon kind={MDSIconKind.ArrowUpRight} slot={MDSButtonSlotName.RightIcon} />
            </MDSButton>
            <MDSButton onPress={handleChatGPTConnect}>
              <MDSIcon kind={MDSIconKind.OpenAI} slot={MDSButtonSlotName.LeftIcon} />
              Connect Mem with ChatGPT
              <MDSIcon kind={MDSIconKind.ArrowUpRight} slot={MDSButtonSlotName.RightIcon} />
            </MDSButton>
          </StyledButtonRow>
        </SettingsIntegrationSection>
      </SettingsIntegrationScrollableArea>
    </SettingsIntegrationPageWrapper>
  );
};
